<template>
  <div class="hello">
    <div class="bg">
      <img src="../assets/poker/bg2.png" />
    </div>
    <div class="msg">{{ msg }}</div>
    <div class="msg">
      LINE ID: @ipoker(要加“＠“哦)<br /><br />手機請點這
      <b-icon icon="hand-index" class="ml-1 mr-1" rotate="90" animation="cylon"></b-icon>
      <a href="https://lin.ee/zZPbY3x"
        ><img
          src="https://scdn.line-apps.com/n/line_add_friends/btn/zh-Hant.png"
          alt="加入好友"
          height="36"
          border="0"
      /></a><br /><br />
      <img src="https://qr-official.line.me/sid/M/270nqvhp.png?shortenUrl=true&appendQueryParameter=oat__id%3D1118086">
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloiPoker",
  data() {
    return {
      msg: "歡迎來到iPoker，賽事查詢、資金管理等更多功能請至LINE官方帳號使用。",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -999;
}
.bg img {
  min-height: 100%;
  width: 100%;
}
.hello {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.msg {
  font-size: 1.4rem;
  text-align: center;
  word-wrap: break-word;
  width: 90%;
  color: black;
  background-color: burlywood;
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 0.8rem;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloiPoker.vue